(function () {
  'use strict';

  if (window.PrewornProductOutfitStartLoaded) return;
  window.PrewornProductOutfitStartLoaded = true;

  var WISHLIST_KEY = 'preworn:wishlist';
  var OUTFIT_START_KEY = 'preworn:outfit-start:v1';
  var OUTFIT_URL = '/pages/build-an-outfit';

  function readJson(value, fallback) {
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  function readWishlist() {
    var parsed = readJson(window.localStorage.getItem(WISHLIST_KEY) || '[]', []);
    return Array.isArray(parsed) ? parsed : [];
  }

  function itemMatches(left, right) {
    if (!left || !right) return false;
    if (String(left.id || '') && String(left.id || '') === String(right.id || '')) return true;
    return !!(left.handle && right.handle && String(left.handle) === String(right.handle));
  }

  function itemIndex(items, item) {
    for (var index = 0; index < items.length; index++) {
      if (itemMatches(items[index], item)) return index;
    }
    return -1;
  }

  function dispatchWishlist(item, saved, count) {
    if (typeof window.CustomEvent !== 'function') return;
    window.dispatchEvent(new CustomEvent('preworn:wishlist-change', {
      detail: { item: item, saved: saved, count: count }
    }));
  }

  function writeWishlist(items, item, saved) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      dispatchWishlist(item, saved, items.length);
      return true;
    } catch (error) {
      return false;
    }
  }

  function saveItem(item) {
    var items = readWishlist();
    var index = itemIndex(items, item);
    if (index === -1) items.unshift(item);
    else items[index] = Object.assign({}, items[index], item);
    return writeWishlist(items, item, true);
  }

  function removeItem(item) {
    var items = readWishlist();
    var index = itemIndex(items, item);
    if (index === -1) return true;
    items.splice(index, 1);
    return writeWishlist(items, item, false);
  }

  function isSaved(item) {
    return itemIndex(readWishlist(), item) !== -1;
  }

  function storeStartingPiece(product) {
    try {
      window.localStorage.setItem(OUTFIT_START_KEY, JSON.stringify({
        version: 1,
        savedAt: Date.now(),
        pending: true,
        product: product
      }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function outfitHref(product) {
    var handle = String(product && product.handle || '').trim();
    return OUTFIT_URL + (handle ? '?start_product=' + encodeURIComponent(handle) : '') + '#BuildAnOutfit';
  }

  function setStatus(root, message, error) {
    var status = root.querySelector('[data-pw-product-outfit-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', !!error);
  }

  function render(root, item) {
    var saved = isSaved(item);
    var button = root.querySelector('[data-pw-product-outfit-save]');
    var label = root.querySelector('[data-pw-product-outfit-save-label]');
    root.classList.toggle('is-saved', saved);
    if (button) button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    if (label) label.textContent = saved ? 'Saved to Wishlist' : 'Add to Wishlist';
  }

  function parseRoot(root) {
    var script = root.querySelector('[data-pw-product-outfit-json]');
    var data = script ? readJson(script.textContent || '{}', null) : null;
    if (!data || !data.wishlist || !data.outfit) return;

    render(root, data.wishlist);
    root.addEventListener('click', function (event) {
      var save = event.target.closest('[data-pw-product-outfit-save]');
      var build = event.target.closest('[data-pw-product-outfit-build]');
      if (save) {
        var saved = isSaved(data.wishlist);
        var updated = saved ? removeItem(data.wishlist) : saveItem(data.wishlist);
        if (!updated) {
          setStatus(root, 'This piece could not be saved in this browser. Please try again.', true);
          return;
        }
        render(root, data.wishlist);
        setStatus(root, saved ? 'Removed from Saved Items.' : 'Saved. You can now use this piece to start an outfit.');
      }
      if (build) {
        if (!saveItem(data.wishlist) || !storeStartingPiece(data.outfit)) {
          setStatus(root, 'Your starting piece could not be saved in this browser. Please try again.', true);
          return;
        }
        render(root, data.wishlist);
        setStatus(root, 'Saved. Opening Outfit Builder with this piece locked in…');
        window.location.assign(outfitHref(data.outfit));
      }
    });

    window.addEventListener('storage', function (event) {
      if (event.key === WISHLIST_KEY) render(root, data.wishlist);
    });
    window.addEventListener('preworn:wishlist-change', function () {
      render(root, data.wishlist);
    });
  }

  function placeOutfitPanel(root, desktop) {
    if (!root || !root.closest) return;
    var section = root.closest('section[id^="MainProduct-"]');
    if (!section) return;
    if (!root._pwOutfitMobileHome) root._pwOutfitMobileHome = root.parentNode;
    var desktopSlot = section.querySelector('[data-pw-product-outfit-desktop-slot]');
    var destination = desktop && desktopSlot ? desktopSlot : root._pwOutfitMobileHome;
    if (destination && root.parentNode !== destination) destination.appendChild(root);
  }

  function bindOutfitPlacement(root) {
    if (!root || root.getAttribute('data-pw-product-outfit-placement-bound') === 'true') return;
    root.setAttribute('data-pw-product-outfit-placement-bound', 'true');
    root._pwOutfitMobileHome = root.parentNode;
    var query = typeof window.matchMedia === 'function'
      ? window.matchMedia('(min-width: 750px)') : null;
    var sync = function () { placeOutfitPanel(root, Boolean(query && query.matches)); };
    sync();
    if (!query) return;
    if (typeof query.addEventListener === 'function') query.addEventListener('change', sync);
    else if (typeof query.addListener === 'function') query.addListener(sync);
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll('[data-pw-product-outfit-start]');
    for (var index = 0; index < roots.length; index++) {
      bindOutfitPlacement(roots[index]);
      if (roots[index].getAttribute('data-pw-product-outfit-bound') === 'true') continue;
      roots[index].setAttribute('data-pw-product-outfit-bound', 'true');
      parseRoot(roots[index]);
    }
  }

  window.PrewornProductOutfitStart = {
    wishlistKey: WISHLIST_KEY,
    outfitStartKey: OUTFIT_START_KEY,
    outfitHref: outfitHref,
    itemMatches: itemMatches,
    place: placeOutfitPanel,
    refresh: init
  };

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
